export default {
  title: 'Estimator24 — Real Estate Valuation Service',
  description: 'Accurate price analysis, AI-based valuation, and market dynamics forecasting',
  login: 'Login to Dashboard'
}
